import * as pubsub from "pubsub-js";

enum ExternalServiceConfiguredEvents {
	// When SharePoint becomes configured
	sharePoint = "externalServiceConfigured.sharePoint"
}

type Data<T extends ExternalServiceConfiguredEvents> =
	T extends ExternalServiceConfiguredEvents.sharePoint ? undefined :
	never;

export const subscribe: <T extends ExternalServiceConfiguredEvents>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends ExternalServiceConfiguredEvents>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
export {
	ExternalServiceConfiguredEvents
};
